<div class="border-top border-primary mt-2">
  @if (selectedModels.length < 2) {
    <div class="alert alert-info">
      {{ 'COMPARISON_TAB.NOTIFICATIONS_MSG' | translate }}
    </div>
  }
  @if (selectedModels.length >= 2) {
    <div class="table-responsive">
      <div class="comparison-container">
        @for (row of comparisonData; track row; let rowIndex = $index) {
          <div class="comparison-row" [ngClass]="{ 'fw-semibold': rowIndex === 0 }">
            <div
              class="comparison-cell title-cell fw-semibold"
              [ngClass]="{ 'bg-comparison-table-odd-row': isOdd(rowIndex), 'bg-white': isEven(rowIndex) }">
              {{ row.title | translate }}
            </div>
            @for (model of selectedModels; track model; let i = $index) {
              <div
                class="comparison-cell data-cell"
                [ngClass]="{ 'bg-comparison-table-odd-row': isOdd(rowIndex), 'bg-white': isEven(rowIndex) }">
                {{ row['model' + (i + 1)] }}
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
